import { useHttpClient } from "./use-http-client";

const httpClient = useHttpClient();

export { httpClient };
